/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    template?: string;
    /**
     * 
     * @type {Date}
     * @memberof Event
     */
    start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Event
     */
    end?: Date;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    subtype?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    organizer?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    organizerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    organizerPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    organizerId?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    body?: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    numberOfSeats?: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    videoLink?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    videoMeeting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    subject?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    isSignedUp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    participantStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    programmeActivityFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    teamsMeetingJoinUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    onlineGroupLink?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    directions?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    directionsEnglish?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    readonly isPersonalAppointment?: boolean;
}

/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'template': !exists(json, 'Template') ? undefined : json['Template'],
        'start': !exists(json, 'Start') ? undefined : (new Date(json['Start'])),
        'end': !exists(json, 'End') ? undefined : (new Date(json['End'])),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'subtype': !exists(json, 'Subtype') ? undefined : json['Subtype'],
        'organizer': !exists(json, 'Organizer') ? undefined : json['Organizer'],
        'organizerEmail': !exists(json, 'OrganizerEmail') ? undefined : json['OrganizerEmail'],
        'organizerPhone': !exists(json, 'OrganizerPhone') ? undefined : json['OrganizerPhone'],
        'organizerId': !exists(json, 'OrganizerId') ? undefined : json['OrganizerId'],
        'location': !exists(json, 'Location') ? undefined : json['Location'],
        'address': !exists(json, 'Address') ? undefined : json['Address'],
        'zip': !exists(json, 'Zip') ? undefined : json['Zip'],
        'city': !exists(json, 'City') ? undefined : json['City'],
        'body': !exists(json, 'Body') ? undefined : json['Body'],
        'numberOfSeats': !exists(json, 'NumberOfSeats') ? undefined : json['NumberOfSeats'],
        'videoLink': !exists(json, 'VideoLink') ? undefined : json['VideoLink'],
        'videoMeeting': !exists(json, 'VideoMeeting') ? undefined : json['VideoMeeting'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'subject': !exists(json, 'Subject') ? undefined : json['Subject'],
        'isSignedUp': !exists(json, 'IsSignedUp') ? undefined : json['IsSignedUp'],
        'participantStatus': !exists(json, 'ParticipantStatus') ? undefined : json['ParticipantStatus'],
        'programmeActivityFormat': !exists(json, 'ProgrammeActivityFormat') ? undefined : json['ProgrammeActivityFormat'],
        'teamsMeetingJoinUrl': !exists(json, 'TeamsMeetingJoinUrl') ? undefined : json['TeamsMeetingJoinUrl'],
        'onlineGroupLink': !exists(json, 'OnlineGroupLink') ? undefined : json['OnlineGroupLink'],
        'directions': !exists(json, 'Directions') ? undefined : json['Directions'],
        'directionsEnglish': !exists(json, 'DirectionsEnglish') ? undefined : json['DirectionsEnglish'],
        'isPersonalAppointment': !exists(json, 'IsPersonalAppointment') ? undefined : json['IsPersonalAppointment'],
    };
}

export function EventToJSON(value?: Event | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Template': value.template,
        'Start': value.start === undefined ? undefined : (value.start.toISOString()),
        'End': value.end === undefined ? undefined : (value.end.toISOString()),
        'Type': value.type,
        'Subtype': value.subtype,
        'Organizer': value.organizer,
        'OrganizerEmail': value.organizerEmail,
        'OrganizerPhone': value.organizerPhone,
        'OrganizerId': value.organizerId,
        'Location': value.location,
        'Address': value.address,
        'Zip': value.zip,
        'City': value.city,
        'Body': value.body,
        'NumberOfSeats': value.numberOfSeats,
        'VideoLink': value.videoLink,
        'VideoMeeting': value.videoMeeting,
        'Status': value.status,
        'Subject': value.subject,
        'IsSignedUp': value.isSignedUp,
        'ParticipantStatus': value.participantStatus,
        'ProgrammeActivityFormat': value.programmeActivityFormat,
        'TeamsMeetingJoinUrl': value.teamsMeetingJoinUrl,
        'OnlineGroupLink': value.onlineGroupLink,
        'Directions': value.directions,
        'DirectionsEnglish': value.directionsEnglish,
    };
}

